import { render, staticRenderFns } from "./ProfileDomainData.vue?vue&type=template&id=bb7d8d30&"
import script from "./ProfileDomainData.vue?vue&type=script&lang=js&"
export * from "./ProfileDomainData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports